// The cart builder's VPS region picker: which regions to offer for a tier.
//
// 2026-10-23: the picker was a static list, a rep picked a region DigitalOcean
// does not sell the Nook's size in (Regular s-1vcpu-2gb is absent from sfo3),
// and the customer was charged and refunded. squish-backend now answers which
// regions can build each tier (GET /api/v2/internal/catalogs/hosting-regions,
// passed through /api/products/live as `hostingRegions`). squish-backend also
// refuses a bad region when the cart is sent; this keeps the rep from picking
// one in the first place.
//
// Lives outside the component so it runs under `node --test`.

// Curated labels, nyc3 first = the default when it can build the tier.
export const VPS_REGIONS = [
  ['nyc3', '🇺🇸 New York'],
  ['sfo3', '🇺🇸 San Francisco'],
  ['tor1', '🇨🇦 Toronto'],
  ['ams3', '🇳🇱 Amsterdam'],
  ['fra1', '🇩🇪 Frankfurt'],
  ['lon1', '🇬🇧 London'],
  ['sgp1', '🇸🇬 Singapore'],
  ['blr1', '🇮🇳 Bangalore'],
  ['syd1', '🇦🇺 Sydney'],
];

// regionsBySku: { sku: [slugs] } from squish-backend, or null/undefined when
// it could not be asked. Unknown answers offer every region: the send-time
// check still refuses a bad one, and an empty picker would block the sale.
export function regionsFor(sku, regionsBySku) {
  const list = regionsBySku && Array.isArray(regionsBySku[sku]) ? regionsBySku[sku] : null;
  if (!list) return VPS_REGIONS;
  return VPS_REGIONS.filter(([slug]) => list.includes(slug));
}

// The region a newly added tier starts on: nyc3 when it can build the tier,
// otherwise the first region that can, otherwise nyc3 (and the picker says
// nothing can build it).
export function defaultRegionFor(sku, regionsBySku) {
  const options = regionsFor(sku, regionsBySku);
  if (options.some(([slug]) => slug === 'nyc3')) return 'nyc3';
  return options[0]?.[0] || 'nyc3';
}

// A line's region after the availability answer arrives: kept when it can
// build the tier, moved to the default when it cannot.
export function reconcileRegion(sku, current, regionsBySku) {
  const options = regionsFor(sku, regionsBySku);
  if (current && options.some(([slug]) => slug === current)) return current;
  return defaultRegionFor(sku, regionsBySku);
}
